export type SortByDirection = 'ASC' | 'DESC';

export const VALID_SORT_DIRECTIONS = new Set<SortByDirection>(['ASC', 'DESC']);

export const parseSortDirection = (
  param: string | null,
  fallback: SortByDirection = 'DESC',
): SortByDirection =>
  param && VALID_SORT_DIRECTIONS.has(param as SortByDirection)
    ? (param as SortByDirection)
    : fallback;
